import {createInvoker}        from '@ali/xcore/invoker.async';
import gatewayInvokeTransform from '../middlewares/qianniu-pc-gateway-invoke-transform';
import routesComplete         from '../middlewares/qianniu-pc-routes-complete';
import invokeNative           from '../middlewares/qianniu-pc-invoke-native';
import API_TYPE               from '../plugins/qianniu-pc-api-type';

let {QN_GATEWAY} = API_TYPE;

function InvokerQianniu(type = 'QN') {
  let Invoker = createInvoker(type);

  switch (type) {
    case QN_GATEWAY:
      Invoker.use(gatewayInvokeTransform);
      break;
    default:
  }
  Invoker
    .use(routesComplete)
    .use(invokeNative)

  return Invoker;
}

export default InvokerQianniu;



// WEBPACK FOOTER //
// ./src/invokers/qianniu-pc.js